import Vue from 'vue'
import { $themeConfig } from '@themeConfig'

// API divisions service - workshops (места печати)
const DIVISIONS_API_URL = $themeConfig.app.backUrlDivisions

/**
 * Получение мест печати (cooking workshops) для подразделения
 * GET /api/divisions/v1/workshops?division_id=...
 * @param {string} divisionId - ID подразделения
 */
export function fetchDivisionWorkshops(divisionId) {
    return Vue.axios.get(`${DIVISIONS_API_URL}/workshops`, {
        params: { division_id: divisionId },
    })
}

/**
 * Получение привязок блюд к местам печати
 * GET /api/divisions/v1/menu-item-workshops?division_id=...
 * @param {string} divisionId - ID подразделения
 */
export function fetchMenuItemWorkshops(divisionId) {
    return Vue.axios.get(`${DIVISIONS_API_URL}/menu-item-workshops`, {
        params: { division_id: divisionId },
    })
}

/**
 * Массовое обновление привязок блюд к местам печати
 * PUT /api/divisions/v1/menu-item-workshops/bulk
 * @param {Object} payload - { division_id, items: [{ menu_item_id, cooking_workshop_ids }] }
 */
export function bulkUpdateMenuItemWorkshops(payload) {
    return Vue.axios.put(`${DIVISIONS_API_URL}/menu-item-workshops/bulk`, payload)
}

/**
 * Обновление привязки одного блюда к местам печати
 * PUT /api/divisions/v1/menu-item-workshops
 * @param {Object} payload - { menu_item_id, cooking_workshop_ids }
 */
export function updateMenuItemWorkshop(payload) {
    return Vue.axios.put(`${DIVISIONS_API_URL}/menu-item-workshops`, payload)
}

// ═══════════════════════════════════════════════
// MENU ITEM NO PRINT (печать отключена)
// ═══════════════════════════════════════════════

/**
 * Получение списка блюд с отключённой печатью
 * GET /api/divisions/v1/menu-item-no-print?division_id=...
 * @param {string} divisionId - ID подразделения
 */
export function fetchMenuItemNoPrint(divisionId) {
    return Vue.axios.get(`${DIVISIONS_API_URL}/menu-item-no-print`, {
        params: { division_id: divisionId },
    })
}

/**
 * Массовое отключение печати для блюд
 * POST /api/divisions/v1/menu-item-no-print/batch → 204
 * @param {Object} payload - { division_id, menu_item_ids }
 */
export function batchSetMenuItemNoPrint(payload) {
    return Vue.axios.post(`${DIVISIONS_API_URL}/menu-item-no-print/batch`, payload)
}

/**
 * Массовое включение печати для блюд
 * DELETE /api/divisions/v1/menu-item-no-print/batch → 204
 * @param {Object} payload - { division_id, menu_item_ids }
 */
export function batchDeleteMenuItemNoPrint(payload) {
    return Vue.axios.delete(`${DIVISIONS_API_URL}/menu-item-no-print/batch`, { data: payload })
}
